import { render, staticRenderFns } from "./BackgroundLogo.vue?vue&type=template&id=29c1272d&scoped=true&"
import script from "./BackgroundLogo.vue?vue&type=script&lang=js&"
export * from "./BackgroundLogo.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundLogo.vue?vue&type=style&index=0&id=29c1272d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c1272d",
  null
  
)

export default component.exports